export class CompanyBranchEntity {  
    id?: number;
    name?: string | null;
    brandProfileImageUrl?: string | null;
    locationName?: string | null;
    locationAddressDescription?: string | null;
    serviceName?: string | null;
    serviceId?: number;
}


